import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';

const CLASS_TYPES = ['group', '1on1', 'all'];
const CLASS_STATES = ['archived', 'current', 'all'];

export const schema = Joi.object().keys({
	schoolId: Joi.number().integer().required(),
	type: Joi.string().valid(CLASS_TYPES).required(),
	state: Joi.string().valid(CLASS_STATES).required(),
	amount_per_page: Joi.number().allow(''),
	current_page_number: Joi.number().allow(''),
	keyword: Joi.string().allow(''),
	order_by: Joi.number().allow(''),
	detail: Joi.number().allow('')
});

export default function getClassBy(opts) {

	let validateResult = Joi.validate(opts, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  const type = CLASS_TYPES.indexOf(opts.type);
  const state = CLASS_STATES.indexOf(opts.state);

	let query = queryString.stringify({
		amount_per_page: opts.amount_per_page,
		current_page_number: opts.current_page_number,
		keyword: opts.keyword,
		order_by: opts.order_by,
		detail: opts.detail
	});

	return new Promise((resolve, reject)=>{
		axios.put('/proxy', {
        'uri': `/g_clslstbytype/${opts.schoolId}/${type}/${state}/?${query}`,
				'method': 'GET',
				'token': localStorage.getItem('token'),
			})
			.then((res) => {
				resolve(res.data);

			})
      .catch((err) => {
        reject(err);
      })

	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/class/getClassBy.js